import { css } from '@emotion/react'
import { memo } from 'react'

export const NotificationIcon = memo(() => (
	<svg
		width="28"
		height="28"
		viewBox="0 0 28 28"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		css={css`
			display: block;
		`}
	>
		<path
			d="M24.15 13.6177C24.1541 15.1887 23.7871 16.7385 23.0788 18.1409C22.2389 19.8213 20.9478 21.2347 19.35 22.2228C17.7523 23.2108 15.911 23.7346 14.0324 23.7353C12.4613 23.7394 10.9115 23.3724 9.50921 22.664L3.7334 24.2467L4.98603 18.1409C4.27772 16.7385 3.91066 15.1887 3.91475 13.6177C3.91548 11.7391 4.43922 9.89778 5.4273 8.30002C6.41539 6.70227 7.8288 5.41116 9.50921 4.57131C10.9115 3.863 12.4613 3.49594 14.0324 3.50003H14.6275C17.1086 3.63691 19.4519 4.68411 21.2089 6.44112C22.966 8.19814 24.0132 10.5415 24.15 13.0225V13.6177Z"
			stroke="currentColor"
			strokeWidth="2.1"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
))
